import { html } from 'htm/preact';
import {Router} from 'preact-router';
import {WizardSteps, WizardHeading, WizardProgressBar, successText, erorrText} from '../../components/Wizard.js';
import { useState, useEffect } from 'preact/hooks';
import { Fragment, Component } from 'preact';

import { signal } from "@preact/signals";

import DriverGeneralInformation from './DriverGeneralInformation.js';
import DriverEmployerInformation from './DriverEmployerInformation.js';
import DriverLicenseInformation from './DriverLicenseInformation.js';
import DriverTrafficConvictions from './DriverTrafficConvictions.js';
import DriverAccidentRecord from './DriverAccidentRecord.js';
import DriverNatureAndExperiance from './DriverNatureAndExperiance.js';
import Match from 'preact-router/match';
import Redirect from '../../pages/Redirect.js';


const selectStepData = signal(null);
const isStepInfoLoading = signal(true);

const getStepMainHeading = (s) => {
    let text = '';
    switch(parseInt(s) ){
        case 1:
            text='GENERAL INFORMATION';
            break;
        case 2:
            text='EMPLOYMENT RECORD';
            break;
        case 3:
            text='LICENSE INFROMATION';
            break;
        case 4:
            text='TRAFFIC CONVICTIONS';
            break;
        case 5:
            text='ACCIDENT RECORD';
            break;
        case 6:
            text='NATURE AND EXTENT OF EXPERIENCE';
            break;
    }
    return text;
}

const getCurrentStepData = ( step=1 )  => 
	{
	    const id = window.location ? window.location.pathname.split('/')[2] : '';
	    const url = '/registerdriver/:id/getLastStep'.replace(':id', id);
	    return fetch(url).then(r=> r.json()).then(d => {
	        
	        if( d.data )
	        {
	            selectStepData.value = d.data;
	        }
	        
	    }).catch( e => {
	        
	        
	    })
	}

export default function wizard(props)
{
    const [currentStep, setCurrentStep] = useState(1);
    const selectedHeading =  signal(getStepMainHeading(currentStep));
    
    useEffect( () => {
        
        

    }, [] );
    
    const totalsteps = 6;

	const _next = () => {
		let currentStepnew = currentStep;
	   if (currentStepnew >= 4) {
	     currentStepnew = 4;
	   } else {
	     currentStepnew = currentStep + 1;
	   }
	   
	   setCurrentStep(currentStepnew);

	}

	const _prev = () => {
		let currentStepnew = currentStep;
	   if (currentStepnew <= 1) {
	     currentStepnew = 1;
	   } else {
	     currentStepnew = currentStep - 1;
	   }
	   
	   setCurrentStep(currentStepnew);

	}
	
	
	
	/*useEffect( () => {
	    
	    
	    if( currentStep >= 1 )
	    {
	        getCurrentStepData(currentStep);
	    }
	    
	}, [currentStep] );*/
	
	
	
	const handleRoute = async (e) => {
        /*switch (e.url) {
          case '/profile':
            const isAuthed = await this.isAuthenticated();
            if (!isAuthed) route('/', true);
            break;
        }*/
        
        
        
        selectedHeading.value = getStepMainHeading(e.matches.step);
        
        
        console.log(e);
      }; 
	
	return html`
	<div>
	
	<${Router} onChange="${handleRoute}">
			    
			        <${WizardStepsContainer} states="${props.states}" path="/apply/:uid/:step" selectedHeading="${selectedHeading}"  totalsteps="${totalsteps}" currentStep="${currentStep}" _next="${_next}" selectStepData="${selectStepData}" />
			        <${Redirect} path="/apply/:uid" to="/apply/:uid/1" />
			    </${Router}>
			    </div>
	`;	
}


function WizardStepsContainer({selectedHeading,totalsteps,currentStep, _next, selectStepData,  step, uid, states})
{
    
    console.log("WizardStepsContainer" , this);
    
    useEffect(()=>{
        if( step >= 1 )
	    {
	        isStepInfoLoading.value = true;
	        getCurrentStepData(step).then(r => {
	            isStepInfoLoading.value = false;
	        });
	    }
        
    }, [step]);
    
   if( isStepInfoLoading.value )
    {
        return html `
            <div class="relative items-center block h-screen ">
                <div role="status" class="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
                    <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        `;
    }
    
    return html `
        <${Fragment}>
        <div class="${isStepInfoLoading.value ? 'relative items-center block   bg-white dark:bg-gray-800  dark:hover:bg-gray-700 ' : ''}">
        <${Match} path="/apply/${uid}/2">${({ matches, path, url }) => {console.log('url matched : ',matches, path, url )} }</${Match}>
        ${ isStepInfoLoading.value && html `<div role="status" class="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
        <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
        <span class="sr-only">Loading...</span>
    </div>` }
    <div class="${isStepInfoLoading.value && 'opacity-20'}">
        <${WizardProgressBar} heading="CDL Driver Application Progress ${((100 / totalsteps) * step).toFixed(0)}%" progress="${(100 / totalsteps) * step}" />
			<br />
			
			<div class="bg-white">
    			<${WizardSteps} uid="${uid}" currentStep="${step}" />
    			<${WizardHeading} text="${getStepMainHeading(step)}" />
    			<br />
    			<br />
    			
			</div>
			<hr />
			<div>
			    
			    ${ step == 1 && html `<${DriverGeneralInformation} states="${states}" _next="${_next}" currentStep=${step} afterValid=${_next} data="${selectStepData}" />`  }
            
            ${ step == 2 && html `<${DriverEmployerInformation} states="${states}" _next="${_next}" currentStep=${step} afterValid=${_next} data="${selectStepData}" />`  }
            
            ${ step == 3 && html `<${DriverLicenseInformation} states="${states}" _next="${_next}" currentStep=${currentStep} afterValid=${_next} data="${selectStepData}" />`  }
            
            ${ step == 4 && html `<${DriverTrafficConvictions} states="${states}" _next="${_next}" currentStep=${step} afterValid=${_next} data="${selectStepData}" />`  }
            
            ${ step == 5 && html `<${DriverAccidentRecord} states="${states}"  _next="${_next}" currentStep=${step} afterValid=${_next} data="${selectStepData}" />`  }
            
            ${ step == 6 && html `<${DriverNatureAndExperiance} states="${states}" _next="${_next}" currentStep=${step} afterValid=${_next} data="${selectStepData}" />`  }
			    
    			    
			</div>
			</div>
            
            </div>
            
	        
        
        </${Fragment}>
    `;
}


